module.exports = __webpack_public_path__ + "img/img2.badaf0e4.png";